var _defs, _line, _line2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFDeskRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eb464424-35d3-46da-8dbb-d00c66124403",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 361.33 133.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".e5ad973b-0b09-458b-a443-c1a73f885761,.fd1be5aa-15e5-4c38-9a76-df1ef21f037c{fill:none;stroke:#6F6F6F;stroke-width:0.5px;}.e5ad973b-0b09-458b-a443-c1a73f885761{stroke-miterlimit:10;}.e0fd6127-0930-4052-9a2c-943f8e8a62a4{fill:#6F6F6F;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "e5ad973b-0b09-458b-a443-c1a73f885761",
    y1: 0.25,
    x2: 357.17,
    y2: 0.25
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "e5ad973b-0b09-458b-a443-c1a73f885761",
    x1: 357.17,
    y1: 124.48,
    x2: 357.17,
    y2: 0.25
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ace5fa08-fd0d-4fc0-9e83-7bd9acf48819",
    "data-name": "Ellipse 4"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "e0fd6127-0930-4052-9a2c-943f8e8a62a4",
    cx: 356.83,
    cy: 129.12,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fd1be5aa-15e5-4c38-9a76-df1ef21f037c",
    cx: 356.83,
    cy: 129.12,
    r: 4.25
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFDeskRight);
export default __webpack_public_path__ + "static/media/F-Desk-Right.fa56a892787f9cbdddf1712de22890f9.svg";
export { ForwardRef as ReactComponent };